import { InternalGrid } from '@paygreen/paygreen-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { spaces } from '../../../utils/constants';
import { IsMobile } from '../../../utils/tools';
import { spacesManagementList } from '../shared';
import AccountManagementCard from './AccountManagementCard';
import { AdministratorManagementCard } from './administratorManagementCard';
import CompanyManagementCard from './CompanyManagementCard';
import { SpaceManagementCard } from './spaceManagementCard';

const AdminUserDetails = ({
    accountData,
    setAccountData,
    setIsLoading,
    isLoading,
    getAccountData,
}) => (
    <>
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="1fr"
            gridGap="lg"
            hasStaticWidth={IsMobile()}
            alignItems="stretch"
            justifyItems="stretch"
        >
            <InternalGrid
                displayType="grid"
                gridTemplateColumns={IsMobile() ? '1fr' : '1fr 1fr'}
                gridGap="lg"
                alignItems="stretch"
                justifyItems="stretch"
            >
                <CompanyManagementCard
                    accountData={accountData}
                    isLoading={isLoading}
                    isShop={true}
                />

                <AdministratorManagementCard
                    accountData={accountData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setAccountData={setAccountData}
                    isShop={true}
                    refresh={getAccountData}
                />
            </InternalGrid>

            <InternalGrid
                displayType="grid"
                gridTemplateColumns={IsMobile() ? '1fr' : '1fr 1fr 1fr'}
                gridGap="lg"
                alignItems="stretch"
                justifyItems="stretch"
            >
                <AccountManagementCard
                    accountData={accountData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setAccountData={setAccountData}
                    isShop={true}
                />

                <SpaceManagementCard
                    mode={spaces.charity}
                    accountData={accountData}
                    setAccountData={setAccountData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    inputList={spacesManagementList.slice(
                        0,
                        accountData?.usesArrondi === '0'
                            ? 1
                            : accountData?.charityBilling?.status === 'UNSIGNED'
                            ? 3
                            : 5,
                    )}
                    refresh={getAccountData}
                />

                <SpaceManagementCard
                    mode={spaces.climate}
                    accountData={accountData}
                    setAccountData={setAccountData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    inputList={spacesManagementList.slice(
                        5,
                        accountData?.usesTree === '0'
                            ? 6
                            : accountData?.climateBilling?.status === 'UNSIGNED'
                            ? 9
                            : 11,
                    )}
                    refresh={getAccountData}
                />
            </InternalGrid>
        </InternalGrid>
    </>
);

AdminUserDetails.propTypes = {
    accountData: PropTypes.object,
    setAccountData: PropTypes.func,
    isLoading: PropTypes.bool,
    setIsLoading: PropTypes.func,
    getAccountData: PropTypes.func,
};

AdminUserDetails.defaultProps = {
    isLoading: true,
};

export default withTranslation('common')(AdminUserDetails);
